import {
    FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST,
    findProcessStatementCommentVisibilitySuccess,
    findProcessStatementCommentVisibilityFailure,
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { message } from "antd";

export function findProcessStatementCommentVisibilityEpic(action$, store$, { ProcessStatementRepository }) {
    return action$.pipe(
        ofType(FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST),
        mergeMap( action => from(ProcessStatementRepository.findCommentVisibility())
            .pipe(
                mergeMap( ({ year, modules }) => {
                    return from ([
                        findProcessStatementCommentVisibilitySuccess({ year, modules }),
                    ]);
                }),
                catchError( error => {
                    return from([
                        findProcessStatementCommentVisibilityFailure(error),
                    ])
                })
            )
        ),
    );
}
